<div class="editor-page">
  <div class="container-xxl editor">
    <header class="editor-head">
      <div class="editor-banner">
        <img src="assets/img/contactBar.png" alt="">
        <h1>Contatti</h1>
      </div>
      <p class="editor-lead">Riferimenti e orari degli uffici della Misericordia di Borgo San Lorenzo.</p>
    </header>

    <section class="editor-panel">
      <h2>Sede</h2>
      <p class="address">Via Giotto, 34 - 50032 - Borgo San Lorenzo (FI) - Italy</p>
      <div class="contact-list">
        <div class="contact-item">
          <span class="contact-label">Per tutti gli uffici</span>
          <strong>tel: 055 84 94 118</strong>
        </div>
        <div class="contact-item">
          <span class="contact-label">Ambulatori della Fondazione</span>
          <strong>tel: 055 84 55 299</strong>
        </div>
        <div class="contact-item">
          <span class="contact-label">Servizi Funebri della Fondazione</span>
          <strong>tel: 055 84 02 758</strong>
        </div>
        <div class="contact-item">
          <span class="contact-label">Fax</span>
          <strong>055 84 95 777</strong>
        </div>
        <div class="contact-item">
          <span class="contact-label">Email</span>
          <strong>home&#64;misericordia.net</strong>
        </div>
        <div class="contact-item">
          <span class="contact-label">Posta elettronica certificata</span>
          <strong>misericordiabsl&#64;legalmail.it</strong>
        </div>
      </div>
    </section>

    <div class="row g-3">
      <div class="col-12 col-md-6">
        <section class="editor-panel office">
          <h2>Ufficio Segreteria &amp; Amministrazione</h2>
          <p>
            <span class="contact-label">Orario</span>
            dal lunedì al sabato ore 9,00 – 12,00
          </p>
          <p>
            <span class="contact-label">Segreteria</span>
            Donatella Giuliani
          </p>
          <p>
            <span class="contact-label">Amministrazione</span>
            Loredana Generini
          </p>
        </section>
      </div>

      <div class="col-12 col-md-6">
        <section class="editor-panel office">
          <h2>Ufficio Trasporti</h2>
          <p>
            <span class="contact-label">Orario</span>
            dal lunedì al venerdì ore 8,00 – 20,00
          </p>
          <p class="office-note">L’accoglienza è prevista solo in orario segreteria o in caso di NON uscita del 118.</p>
        </section>
      </div>

      <div class="col-12 col-md-6">
        <section class="editor-panel office">
          <h2>Ufficio di Presidenza</h2>
          <p>Il Provveditore riceve su appuntamento. Telefonare in segreteria.</p>
          <p>
            <span class="contact-label">Provveditore</span>
            Piero Margheri
          </p>
        </section>
      </div>
    </div>
  </div>
</div>
